import Content from "Types/Content";
import PokemonCard from "../../Componentes/PokeDex/PokemonCard";
import usePokeNames from "./usePokeNames";
import Style from "./style.module.scss";
import { useRef, useState } from "react";
import PokemonModal from "Componentes/PokeDex/PokemonModal";

const Pokemon = () => {
  const [pokemonNames, nextPage, previousPage, currentPage] = usePokeNames();
  const [modalVisible, setmodalVisible] = useState(false);
  const [pokemonIndex, setPokemonIndex] = useState(-1);
  const backgroundRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <div
        className={Style.backgroundPokedex}
        ref={ref => (backgroundRef.current = ref)}>
        <div className={"row row-cols-md-6 m-0 p-0 " + Style.container}>
          {pokemonNames.map((nombre, index) => (
            <PokemonCard
              id={index + currentPage + 1}
              name={nombre}
              onClick={() => {
                setmodalVisible(true);
                setPokemonIndex(index + currentPage + 1);
              }}
            />
          ))}
        </div>
        <div className='pagination justify-content-center p-1'>
          <button className='btn btn-dark w-50' onClick={() => previousPage()}>
            Previous
          </button>
          <button className='btn btn-dark w-50' onClick={() => nextPage()}>
            Next
          </button>
        </div>
      </div>
      <PokemonModal
        id={pokemonIndex}
        visible={modalVisible}
        onClickBack={() => setmodalVisible(false)}
      />
    </>
  );
};

export default new Content({
  Component: Pokemon,
  title: "PokeDex",
  route: "Pokemon"
});
